/**
 * 收藏单选规格弹窗
 */
import React, { useState, useCallback, useEffect } from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { observer } from 'mobx-react'
import { showMsg } from '@utils'
import { format } from '@dt/fe-utils'
import i18n from 'i18next'
import { SelectScales } from '@pages/mall/product/component'
import { Stepper, Icon } from 'components'

import './index.scss'

interface ICartProps {
  cnt?: number;
  product?: IMallFavoProduct;
  // 用于锁定的选项
  disableScaleNo?: string;
  onSelect?: (scaleNo: string) => void;
  reject?: () => void;
  resolve?: (data?: any) => void;
}

const CollectScaleModal: React.FC<ICartProps> = ({ disableScaleNo, product, onSelect, reject, resolve }) => {
  const [cnt, setCnt] = useState(1)
  const [scaleNo, setScaleNo] = useState(product.scaleNo)
  const [scale, setScale] = useState({ no: '', price: 0, actualPrice: 0, cnt: 0 })
  useEffect(() => {
    findScale(product.scaleNo)
  }, [])
  const findScale = (scaleNo: string) => {
    if (scaleNo) {
      const doScale = product.scales.find((scale) => scale.no === scaleNo)
      if (doScale) {
        setScale(doScale as any)
      }
    }
  }
  const handleChangeCnt = useCallback((isAdd: boolean) => {
    let prod = { ...product }
    if (scaleNo) {
      if (isAdd) {
        const { scales } = prod
        const thisScale = scales.find(scale => scale.no === scaleNo)
        if (cnt >= thisScale.cnt) {
          showMsg(i18n.t('mall.outCnt'))
          setCnt(thisScale.cnt)
          return
        }
      } else if (cnt <= 1) { // 至少买一个
        return
      }
      let _cnt = cnt + (isAdd ? 1 : -1)
      prod.cnt = _cnt
      setCnt(_cnt)
    }
  }, [cnt])
  // 验证是否已经选过该规格
  const checkScaleHas = (scaleNo: string) => {
    if ((product.selectScales || []).findIndex((item, i) => item.no === scaleNo && disableScaleNo !== scaleNo) >= 0) {
      showMsg(i18n.t('mall.hasScale'))
      return true
    }
    return false
  }
  const handleChangeScale = (data) => {
    checkScaleHas(data)
    const scale = product.scales.find((scale) => scale.no === data)
    if (scale) {
      setCnt(1)
      setScaleNo(scale.no)
      setScale({ no: scale.no, price: scale.price, actualPrice: scale.actualPrice, cnt: scale.cnt })
      onSelect && onSelect(scale.no)
      findScale(data)
    }
  }

  const handleConfirm = () => {
    const scale = product.scales.find((scale) => scale.no === scaleNo)
    if (checkScaleHas(scaleNo)) return
    resolve({ no: scale.no, selectCnt: cnt, name: scale.name, price: scale.price })
  }

  return (
    <IonModal
      isOpen
      cssClass='mall-product-scale-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='modal-title'>{product.name}</div>
        <Icon name='close' onClick={reject} />
      </IonHeader>
      <IonContent>
        <div className='scale-container'>
          <SelectScales selectScaleNo={disableScaleNo} product={product} onChange={handleChangeScale} />
          <div className='scale-stepper-wrapper'>
            <div className='title space-between'>
              <span>{i18n.t('mall.productCnt')}</span>
            </div>
            <Stepper cnt={cnt} onChange={handleChangeCnt} />
          </div>
        </div>
      </IonContent>
      <IonFooter className='mall-footer-btn-wrap'>
        <div className='footer-btn'>
          {
            !product.scaleNo || scale.cnt <= 0 ? (
              <button className='primary-btn' disabled>
                <div className='btn-txt'>{i18n.t('mall.scaleNotCnt')}</div>
                <div className='price-wrap'>
                  <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.price || 0) }}></span>
                </div>
              </button>
            ) : (
              <button
                className='primary-btn'
                onClick={handleConfirm}
              >
                {!product.scaleNo ? i18n.t('common.soldout') : (
                  <div>
                    {i18n.t('newCart.confirm')}
                    {
                      scaleNo ? <span className='price-wrap' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(scale.price) }}></span> : null
                    }
                  </div>
                )}
              </button>
            )
          }
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CollectScaleModal)
